import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-export-questionnaire-dropdown";

const keys = addTranslations(RESOURCE_NAME, {
    export_answers_in_locale: {
        en: "Export answers in {{locale}}",
        fr: "Exporter les réponses en {{locale}}",
    },
    export_files: {
        en: "Export proof documents",
        fr: "Exporter les documents",
    },
    download_error: {
        en: "Failed to download questionnaire",
        fr: "Erreur lors de la téléchargement du questionnaire",
    },
});

export function useExportQuestionnaireDropdownTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
